import { useEffect, useRef } from 'react';

/**
 * A soft brand glow that trails the cursor (desktop only). Pure transform
 * writes inside a rAF loop — no React re-renders. Mounted once, globally.
 */
export default function CursorGlow() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let raf = 0;
    let tx = window.innerWidth / 2;
    let ty = window.innerHeight / 2;
    let cx = tx;
    let cy = ty;

    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      el.style.opacity = '1';
    };
    const leave = () => (el.style.opacity = '0');
    const loop = () => {
      cx += (tx - cx) * 0.15;
      cy += (ty - cy) * 0.15;
      el.style.transform = `translate3d(${cx - 300}px, ${cy - 300}px, 0)`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener('pointermove', move);
    document.addEventListener('mouseleave', leave);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener('pointermove', move);
      document.removeEventListener('mouseleave', leave);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[60] hidden h-[600px] w-[600px] rounded-full opacity-0 transition-opacity duration-500 md:block"
      style={{
        background: 'radial-gradient(circle, rgba(109,94,252,0.12), rgba(52,231,228,0.05) 40%, transparent 62%)',
        mixBlendMode: 'screen',
        willChange: 'transform',
      }}
    />
  );
}
